import { useEffect, useMemo, useState } from "react";
import "./App.css";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Gallery from "./pages/Gallery";
import Testimonials from "./pages/Testimonials";
import Blog from "./pages/Blog";
import Contact from "./pages/Contact";
import { normalizePath } from "./router";

const pages = {
  "/": Home,
  "/about": About,
  "/services": Services,
  "/gallery": Gallery,
  "/testimonials": Testimonials,
  "/blog": Blog,
  "/contact": Contact,
};

function App() {
  const [currentPath, setCurrentPath] = useState(() => normalizePath(window.location.pathname));
  const [progress, setProgress] = useState(0);
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onRouteChange = () => setCurrentPath(normalizePath(window.location.pathname));
    window.addEventListener("popstate", onRouteChange);
    return () => window.removeEventListener("popstate", onRouteChange);
  }, []);

  useEffect(() => {
    const update = () => {
      const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
      setProgress(maxScroll > 0 ? (window.scrollY / maxScroll) * 100 : 0);
      setShowTop(window.scrollY > 460);
    };

    update();
    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    return () => {
      window.removeEventListener("scroll", update);
      window.removeEventListener("resize", update);
    };
  }, [currentPath]);

  const Page = useMemo(() => pages[currentPath] || Home, [currentPath]);

  return (
    <>
      <div className="bits-scroll-progress" style={{ width: `${progress}%` }} aria-hidden="true" />
      <Navbar currentPath={currentPath} />
      <main>
        <Page />
      </main>
      <Footer />
      <a href="https://wa.me/91XXXXXXXXXX" target="_blank" rel="noreferrer" className="whatsapp" aria-label="WhatsApp">WA</a>
      <button
        type="button"
        className={`back-to-top ${showTop ? "show" : ""}`}
        aria-label="Back to top"
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      />
    </>
  );
}

export default App;
